"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 3c-4.8 0-9 3.86-9 9 0 2.12.74 4.07 1.97 5.61L3 19.59 4.41 21l1.97-1.97C7.93 20.26 9.88 21 12 21c2.3 0 4.61-.88 6.36-2.64C20.12 16.61 21 14.3 21 12V3zm7 9c0 1.87-.73 3.63-2.05 4.95S13.87 19 12 19c-3.86 0-7-3.14-7-7 0-1.9.74-3.68 2.1-4.99C8.42 5.71 10.16 5 12 5h7z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m8.46 12.63 4.05.4-2.44 3.33c-.11.16-.1.38.04.52.15.15.4.16.56.01l5.16-4.63c.33-.3.15-.85-.3-.89l-4.05-.4 2.44-3.33c.11-.16.1-.38-.04-.52-.15-.15-.4-.16-.56-.01l-5.16 4.63c-.32.3-.14.85.3.89"
}, "1")], 'EnergySavingsLeafOutlined');